/* eslint-disable react/no-danger */
import { Heading, SimpleGrid, GridItem, Box } from '@chakra-ui/react';

import { useSignupPageContentQuery } from 'src/generated/graphql';
import sanitizeContent from 'src/utils/sanitizeContent';
import colors from 'src/theme/colors';
import ReviewCarousel from './ReviewCarousel';

export default function ReviewsSection() {
  return (
    <SimpleGrid
      columns={[1, null, 2, 1]}
      columnGap="30px"
      alignContent="middle"
      px={['20px', 0]}
      alignItems="center"
    >
      <GridItem>
        <TopSection />
      </GridItem>
      <GridItem>
        <ReviewCarousel />
      </GridItem>
    </SimpleGrid>
  );
}

function TopSection() {
  const { data, error, loading } = useSignupPageContentQuery({ fetchPolicy: 'cache-and-network' });
  const sidebarContent = data?.signupPageContent?.sidebarContent;
  if (loading) return null;
  return error || !sidebarContent || sidebarContent === '<p></p>' ? (
    <Heading textAlign="center" fontSize="30px" mt="0" mb="29px" color="podcastShade800">
      Join thousands of happy podcasters
    </Heading>
  ) : (
    <Box
      marginBottom="30px"
      css={{
        '& h2': {
          fontSize: '30px',
          marginBottom: '14px',
          color: colors.podcastShade800,
          fontWeight: 'bold',
        },
        '& ul': {
          listStyleType: 'disc',
          marginLeft: '20px',
          marginBottom: '20px',
        },
      }}
      dangerouslySetInnerHTML={{
        __html: sanitizeContent(sidebarContent || ''),
      }}
    />
  );
}
